// react
import * as React from "react";
// material
import Toolbar from "material-ui/Toolbar/Toolbar";
import ToolbarGroup from "material-ui/Toolbar/ToolbarGroup";
import ToolbarTitle from "material-ui/Toolbar/ToolbarTitle";
import IconHelpOutline from "material-ui/svg-icons/action/help-outline";
import IconClear from "material-ui/svg-icons/content/clear";
// global
import HeaderIcon from "./HeaderIcon";
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import FeedbackButton from '../../../feedback/FeedbackButton';
import { DiyFeedbackSubmit } from '../../../feedback/DiyFeedbackSubmit';
import l10n = require("diy/util/l10n");

interface HeaderProps {
    titleText: string;
    onHelpClick?(): void;
    onCloseClick(): void;
}

export class Header extends React.Component<HeaderProps, {}> {

    constructor(props: HeaderProps, context: any) {
        super(props, context);
    };

    render() {
        const styles = this.getStyles();
        return (
            <div style={styles.root}>
                <Toolbar style={styles.toolbar}>
                    <ToolbarGroup key={0} style={styles.toolbarGroup}>
                        <div style={styles.logo}>
                            <HeaderIcon style={styles.logoImg} />
                        </div>
                        <ToolbarTitle text={this.props.titleText} style={styles.title} />
                    </ToolbarGroup>
                    <ToolbarGroup key={1} style={styles.actionsToolbar}>
                        <FeedbackButton
                            feedbackFeatureName=""
                            feedbackContext="onboardingGuide"
                            onFeedbackSubmit={DiyFeedbackSubmit}
                            useAlternativeColors={true}
                            style={styles.iconFeedback}
                        />
                        {
                            this.props.onHelpClick ?
                                <IconTextButton style={styles.iconHelp}
                                    Icon={<IconHelpOutline/>}
                                    useAlternativeColors={true}
                                    onTouchTap={this.props.onHelpClick}
                                    text={l10n.getString('help') }>
                                </IconTextButton>
                                :
                                null
                        }
                        <IconTextButton style={styles.iconClose}
                            Icon={<IconClear/>}
                            useAlternativeColors={true}
                            onTouchTap={this.props.onCloseClick}
                            text={l10n.getString('close') }
                            dataTestId="onboardingGuide-close-button"
                            />
                    </ToolbarGroup>
                </Toolbar>
                <div style={styles.gradient}></div>
            </div>
        );
    };

    private getStyles() {
        return {
            root: {
                position: "relative"
            },
            toolbar: {
                paddingLeft: 0,
                backgroundColor: "rgba(255, 255, 255, 1)"
            },
            toolbarGroup: {
                height: "100%",
                float: "left"
            },
            logo: {
                float: 'left',
                padding: "11px 10px",
                marginLeft: "10px"
            },
            logoImg: {
                fill: "rgba(100, 110, 128, 1)",
                height: "34px",
                width: "34px"
            },
            title: {
                fontFamily: '"Open Sans", sans-serif',
                fontSize: "13px",
                fontWeight: 600,
                textTransform: "uppercase",
                color: "rgba(38, 46, 56, 1)"
            },
            actionsToolbar: {
                marginRight: "-24px",
                float: "right"
            },
            iconHelp: {
                margin: 0,
                marginTop: "4px",
                height: "56px"
            },
            iconClose: {
                margin: 0,
                marginTop: "4px",
                height: "56px"
            },
            iconFeedback: {
                margin: 0,
                marginTop: "4px",
                height: "56px"
            },
            gradient: {
                zIndex: 1,
                left: 0,
                bottom: '-18px',
                position: 'absolute',
                pointerEvents: 'none',
                height: '18px',
                width: '100%',
                opacity: 1,
                transition: 'opacity .3s ease-in-out',
                background: 'linear-gradient(' +
                    'to bottom,' +
                    'rgba(0,0,0,0.08) 0%,' +
                    'rgba(0,0,0,0.02) 35%,' +
                    'rgba(0,0,0,0) 100%' +
                    ')',
                filter: 'progid:DXImageTransform.Microsoft.gradient(' +
                    "startColorstr='#14000000'," +
                    "endColorstr='#00000000'," +
                    "GradientType=0" +
                    ')'
            }
        };
    };

}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/Header.tsx
 **/